import { Typography } from "@mui/material";

function JoiningPage(){
    return (
        <>
            <Typography>
                Joining...Don't refresh.
            </Typography>
        </>
    );
}

export default JoiningPage;